import apiFetch from '../../apiFetch'

export default function (idControlSangre, token) {
  return apiFetch({endPoint: `ControlSangre/eliminarControlSangre?idControlSangre=` + idControlSangre, method: 'GET', body: null, token: token})
}
